import { render, staticRenderFns } from "./identity.vue?vue&type=template&id=c50c5ffa&scoped=true"
import script from "./identity.vue?vue&type=script&lang=js"
export * from "./identity.vue?vue&type=script&lang=js"
import style0 from "./identity.vue?vue&type=style&index=0&id=c50c5ffa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c50c5ffa",
  null
  
)

export default component.exports